module.exports = __webpack_public_path__ + "img/2.e9a6dd5d.png";